<template>
  <span>
    <template v-if="!loader">
      <button
        type="button"
        class="retry-btn"
        :class="classes"
        @click="retry"
        :id="`advertiser-${advertiserId}`"
      >
        <i class="fa fa-repeat"></i>
      </button>
      <b-tooltip
        :target="`advertiser-${advertiserId}`"
        :title="$t('error_problem_creating')"
        container="body"
      ></b-tooltip>
    </template>
    <template v-else>
      <Loader
        :size="'small'"
        :align="'start'"
      />
    </template>
  </span>
</template>

<script>

import AdvertisersService from '@/modules/advertisers/services/advertisers-service'

import Loader from '@/components/common/Loader/Loader'

export default {
  name: 'RetryAdvertiserCreationOnPlatformButton',
  props: ['advertiserId', 'color'],
  components: {
    Loader
  },
  data () {
    return {
      loader: false
    }
  },
  computed: {
    classes () {
      const array = []
      if (this.color) array.push(`color-${this.color}`)
      return array
    }
  },
  methods: {
    /**
     * Retry
     */
    async retry () {
      this.loader = true
      try {
        await AdvertisersService.retryCreationOnPlatform(this.advertiserId)
        this.$emit('retry-successful')
      } catch (error) {
        this.$emit('retry-error', error)
      }
      this.loader = false
    }
  }
}
</script>

<style lang="scss" scoped>
.retry-btn {
  padding: 0;
  margin: 0;
  background: transparent;
  border: none;

  &.color-white {
    color: #fff;
  }
}
</style>
